import { type FireAnalyticsEvent } from '../../../common/types';
import { type CommonAttributes, type NonPrivacySafeAttributes } from './types';

type LeapQueryShownAnalyticsProps = {
	candidatesCount: number;
	titleIndex: number;
	commonAttributes: CommonAttributes;
	nonPrivacySafeAttributes: NonPrivacySafeAttributes;
};

export const onLeapQueryShown = ({
	candidatesCount,
	titleIndex,
	commonAttributes,
	nonPrivacySafeAttributes,
}: LeapQueryShownAnalyticsProps): FireAnalyticsEvent => ({
	eventType: 'track',
	action: 'shown',
	actionSubject: 'leapQuery',
	attributes: {
		additionalAttributes: {
			leapQueryCandidatesCount: candidatesCount,
			lastQueryTitleIndex: titleIndex,
		},
		commonAttributes,
	},
	nonPrivacySafeAttributes,
});
